import {
    GET_MY_DETAILS_REQUEST,
    GET_MY_DETAILS_SUCCESS,
    GET_MY_DETAILS_FAILURE
} from '../actions';


const initialState = {};

const GetMyDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MY_DETAILS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_MY_DETAILS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_MY_DETAILS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default GetMyDetailsReducer;